import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { makeCustomDecimalNumberMask } from '@app/functions';
import { Locale } from '@app/types/translatable.type';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-maximum-accrued-balance-update-card',
    templateUrl: './maximum-accrued-balance-update-card.template.html',
    styleUrls: ['./maximum-accrued-balance-update-card.style.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class MaximumAccruedBalanceUpdateCardComponent implements OnInit {
    @Input() timeOffPolicy = new TimeOffPolicy();

    showMaxBalanceCap = false;

    numberMask = makeCustomDecimalNumberMask(this.translateService.currentLang as Locale);

    constructor(private translateService: TranslateService) {}

    ngOnInit(): void {
        this.showMaxBalanceCap = this.timeOffPolicy.balanceCap === null ? false : !isNaN(this.timeOffPolicy.balanceCap);
    }

    onMaxBalanceCapChange(): void {
        this.timeOffPolicy.balanceCap = null;
    }
}
